var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 96,
    viewBox: "0 0 242 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 50.7216C163.916 49.2906 165.949 49.2906 166.597 50.7216L173.069 65.013C173.492 65.9466 174.6 66.3498 175.524 65.9064L189.668 59.1188C191.084 58.4392 192.641 59.7455 192.218 61.2582L187.989 76.3663C187.713 77.3532 188.303 78.3742 189.295 78.6285L204.493 82.5207C206.015 82.9104 206.368 84.9118 205.071 85.7985L191.045 95.3895C190.742 95.5972 190.382 95.7084 190.014 95.7084H139.851C139.483 95.7084 139.124 95.5972 138.82 95.3895L124.794 85.7985C123.497 84.9118 123.85 82.9104 125.372 82.5207L140.57 78.6285C141.563 78.3742 142.152 77.3532 141.876 76.3663L137.648 61.2583C137.224 59.7455 138.781 58.4392 140.197 59.1188L154.342 65.9064C155.266 66.3498 156.373 65.9466 156.796 65.013L163.268 50.7216Z",
    fill: "#FFDF70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.667 44.5962C61.667 38.1918 66.8588 33 73.2632 33H147.071C153.475 33 158.667 38.1918 158.667 44.5962V83.1128C158.667 89.5172 153.475 94.709 147.071 94.709H73.2632C66.8588 94.709 61.667 89.5172 61.667 83.1128V44.5962Z",
    fill: "white",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1922 34.601C64.7763 33.0372 66.2701 32.0005 67.9394 32.0005H129.058L123.138 54.6248C122.309 57.7917 119.448 60.0005 116.174 60.0005H60.4698C57.6793 60.0005 55.7463 57.2152 56.7226 54.601L64.1922 34.601Z",
    fill: "url(#paint0_linear_2674_28392)",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.424 34.7321C156.879 33.1003 155.351 32 153.631 32H129.507L134.52 54.3759C135.257 57.6633 138.175 60 141.544 60H160.315C163.046 60 164.974 57.3228 164.109 54.7321L157.424 34.7321Z",
    fill: "url(#paint1_linear_2674_28392)",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.216 94.8476L30.7217 94.8477",
    stroke: "#8984FF",
    strokeWidth: 1.79946,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.167 32L129.167 95",
    stroke: "#8984FF",
    strokeWidth: 1.79946
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.6357,
    y: 75.1367,
    width: 11.5098,
    height: 19.9375,
    rx: 4,
    transform: "rotate(90 89.6357 75.1367)",
    fill: "url(#paint2_linear_2674_28392)",
    stroke: "#8984FF",
    strokeWidth: 1.79946
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.504 15.3461L158.86 11.7511C158.152 11.6681 157.562 12.3662 157.804 13.0006L161.311 22.1879C161.465 22.5908 161.91 22.8043 162.36 22.6912L189.502 15.8719C189.804 15.796 189.805 15.3815 189.504 15.3461Z",
    fill: "#8984FF",
    stroke: "#8984FF",
    strokeWidth: 1.64258
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.394 16.2142L169.932 39.246C169.457 39.809 168.531 39.739 168.288 39.1217L163.907 27.9755C163.742 27.555 163.984 27.0584 164.458 26.8465L189.066 15.8382C189.342 15.7149 189.583 15.991 189.394 16.2142Z",
    fill: "#8984FF",
    stroke: "#8984FF",
    strokeWidth: 1.64258
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.305 77.6497L105.021 77.6484M113.22 84.1367L105.019 84.1362",
    stroke: "#8984FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.261 27.3075C155.89 21.9052 133.61 18.7148 132.266 31.4852M39.0159 93.7985C34.2185 72.6945 50.1566 63.9169 60.8004 68.5093M69.5596 30.8656C69.5596 11.1677 96.8161 2.4734 104.817 18.7148C107.108 22.1914 110.147 31.4852 117.316 31.4852",
    stroke: "#8984FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2674_28392",
    x1: 118.658,
    y1: 64.1407,
    x2: 68.4652,
    y2: 15.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.168056,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2674_28392",
    x1: 129.511,
    y1: 64.1402,
    x2: 174.64,
    y2: 35.9653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.168056,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2674_28392",
    x1: 104.981,
    y1: 75.1367,
    x2: 92.4514,
    y2: 100.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.410576,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754862,
    stopColor: "#FFDF70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses2);
export default __webpack_public_path__ + "static/media/courses-2.75e979bb7213522a1ca4627a8a4cb7ba.svg";
export { ForwardRef as ReactComponent };